/**
 * Declared as a constant values because they affect the logic for updating layer and graph name.
 * WARNING: This name will be overwritten by the name of the first added actor on the layer/graph
 */
export const DEFAULT_NAME = {
  LAYER: 'New Layer',
  GRAPH: 'Untitled Graph',
};
